import React from 'react'
import {
    Container, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter,
    Form, FormGroup, Label, Row, Col, Alert
} from 'reactstrap'
import ShowError from './ShowError';
import httpClient from '../myapi'
import Icon from '../styles/icon'
// import store from '../redux/store';
import { $Category } from '../Middleware';
// import { NewImageAdded } from '../redux/actions';

const _webserver = httpClient.WebServerGallery;

const allowedFiles = ['image/jpeg', 'image/jpg', 'image/png']

class ManageModal extends React.Component {
    constructor(props) {
        super(props)

        this.fileRef = React.createRef()

        this.state = {
            imgs: [], //holds all imgs
            imgUrls: [], //holds img urls for preview
            iid: 0,
            price: '',
            disc: '',
            cat: '',
            processing: false,
            modalLabel: 'New ',
            imgError: false,//if non-img file selected
            formError: '', //other than image, msg
            selectCount: 0,
            uploadedCount: 0, editSucess: false,
            categories: [],
            editTried: false, //for breaking recursion
        }

        if (props.action === 2) {
            this.state.modalLabel = 'Edit ';
            this.state.price = parseInt(props.img.price, 10);
            this.state.disc = parseInt(props.img.disc, 10);
            this.state.iid = props.img.id;
            this.state.cat = props.img.cat === null ? '' : props.img.cat;
            
        }

        this.uploadQueue = []; //upload spool
        this.uploadedIndex = 0;
    }
    fileSelected = () => {
        const img = this.fileRef.current.files[0];

        this.imgChanged = true;

        //VALIDATE
        if (!this.isValid(img)) {
            return
        }

        const reader = new FileReader()
        reader.readAsDataURL(img)

        let arr = [], arr2 = [];//when edit, replace image
        if (this.props.action === 1) {
            //NEW IMAGE, CAN ADD MULTIPLE
            arr = this.state.imgUrls.slice();
            arr2 = this.state.imgs.slice();
        }

        reader.onloadend = () => {
            arr.push({ img: reader.result, uploaded: 0 });
            arr2.push(img);

            this.setState({
                imgUrls: arr,
                imgs: arr2,
                imgCount: this.state.selectCount + 1
            })
        }
    }
    isValid(img) {
        this.setState({ imgError: false })
        //IF FILE SELECTED
        if (!img) {
            return
        }
        //ALLOW ONLY IMAGES
        if (allowedFiles.indexOf(img.type) < 0) {
            this.setState({ imgError: true })
            return
        }
        return true
    }
    unSelectImg = (index) => {
        const arr = this.state.imgs.slice();
        const arr2 = this.state.imgUrls.slice();
        arr.splice(index, 1);
        arr2.splice(index, 1);
        this.setState({
            imgs: arr, imgUrls: arr2
        })
    }
    submitForm = (e) => {
        if (!this.allValid()) {
            return;
        }
        e.preventDefault()
        this.setState({
            processing: true, submitted: true
        })
        if (this.props.action === 2 && this.state.imgs.length === 0) {
            //ACTION: EDIT, NO IMG SELECTED (use current image)
            this.uploadQueue.push(null);
            this.uploadImg();
        } else {
            //ACTION:BOTH, WHEN NEW IMG(S) SELECTED
            // this.state.imgs.forEach((img, ind) => {
            this.uploadQueue = this.state.imgs;
            this.uploadImg();
            // });
        }
    }
    uploadImg = () => {
        let img = this.uploadQueue[0];
        if (this.props.action === 2 && !this.uploadQueue.length && !this.state.editTried) {//edit but no image changed
            //editTried : avoids infinite recursion
            img = null;
        } else
            if (!this.uploadQueue.length) {
                this.setState({ multiUploadSuccess: true })
                return;
            }

        const sendData = {
            img: img,
            data: {
                action: this.props.action,
                iid: this.state.iid,
                price: this.state.price,
                cat: this.state.cat,
                disc: this.state.disc,
                imgChanged: img === null ? false : true
            }
        }
        httpClient.upload('/uploadImg.php', sendData).then((res) => {
            this.setState({ editTried: true});
            if (res === '*') {
                if (this.props.action === 1) {

                    const arr = this.state.imgUrls.slice();
                    arr[this.uploadedIndex].uploaded = 1;
                    this.setState({
                        imgUrls: arr, imgCount: this.state.imgCount - 1
                    })
                } else {
                    this.setState({
                        editSucess: true
                    })
                }
            } else {
                this.setState({ processing: false })
            }
            //RECURSION
            this.uploadQueue.splice(0, 1);//remove first item from queue
            this.uploadedIndex++;
            this.uploadImg();
        })
    }
    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }
    closeModal = () => {
        this.props.toclose()
    }
    allValid = () => {
        this.setState({ formError: '' });

        const { price, cat } = this.state;
        if (cat === null || cat === '') {
            this.setState({ formError: 'Select Category' });
            return;
        } else if (isNaN(parseInt(price, 10)) || price < 1) {
            this.setState({ formError: 'Enter Price' });
            return;
        } else if(this.props.action === 1 && !this.state.imgs.length){
            this.setState({formError: 'Select atleast 1 image'});
            return;
        }
        return true;
    }
    componentDidMount(){
        //GET CATEGORIES & SAVE IN STORE
        $Category.getCategories().then(cats =>{
            this.setState({ categories: cats});
        })
    }   
    render() {
        return (
            <Modal isOpen={true} toggle={this.toggle}>
                <ModalHeader>{this.state.modalLabel} Saree</ModalHeader>
                <ModalBody>
                    <Container fluid>
                        <Form onSubmit={this.submitForm}>
                            <Row>
                                <Col sm={12}>
                                    {
                                        this.props.action === 2
                                        && <Label>Product Id: <b>#{this.props.img.id}</b></Label>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Input 
                                        type="select" value={this.state.cat}
                                        onChange={this.handleChange('cat')}>
                                        <option hidden>--Select Category--</option>
                                        {
                                            this.state.categories.map((op, ind) => (
                                                <option key={ind} value={op.cid}>{op.cname}</option>
                                            ))
                                        }
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Price</Label>

                                        <Input type="number"
                                            placeholder="Price of saree"
                                            value={this.state.price}
                                            onChange={this.handleChange('price')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Discount</Label>
                                        <Input type="number"
                                            placeholder="Enter Discount of saree"
                                            value={this.state.disc}
                                            onChange={this.handleChange('disc')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {/*SELECT FILE*/}
                            <SelectFile
                                fileRef={this.fileRef}
                                fileSelected={this.fileSelected}
                            />
                            {this.state.imgError && <ShowError />}
                            <Row>
                                <Col sm={12}>
                                    {
                                        this.props.action === 1
                                            ? this.state.imgUrls.map((img, ind) => (
                                                <PreviewImg
                                                    key={ind}
                                                    img={img}
                                                    deselectFn={() => this.unSelectImg(ind)}
                                                />
                                            ))
                                            : this.state.imgUrls.length
                                                ? <PreviewEdit img={this.state.imgUrls[0].img} />
                                                : <PreviewEdit img={_webserver + this.props.img.srcnm} />
                                    }
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    {
                        (this.state.editSucess || this.state.multiUploadSuccess) && <Alert color="success" style={{padding: 6, float: 'left'}}>Uploaded</Alert>
                    }
                    {
                        //SHOW FORM ERROR
                        this.state.formError && <ShowError msg={this.state.formError} />
                    }
                    {
                        this.state.editSucess || this.state.multiUploadSuccess
                            ? <Button color="success" outline onClick={this.props.onsuccess}>Okay</Button>

                            : <div><MyButton
                                disableOn={this.state.processing}
                                showProgress={this.state.processing}
                                submit={this.submitForm}
                            />{' '}
                                <Button color="secondary" onClick={this.closeModal}>Cancel</Button>
                            </div>
                    }
                </ModalFooter>
            </Modal>
        )
    }
}
export default ManageModal;

const PreviewImg = ({ img, deselectFn }) => {
    return (
        <div className="imgPreview">

            {img.uploaded === 0 && <div className="removeBtn" onClick={deselectFn}>
                <Icon icon="fa-times-circle" /> Remove</div>}
            {img.uploaded === 1 && <div className="discount"><Icon icon="fa-check" /> Uploaded</div>}
            <img src={img.img}
                width="100%"
                alt="Preview" />
        </div>
    )
}
const PreviewEdit = ({ img }) => {
    return (
        <img src={img}
            width="100%"
            alt="Preview" />
    )
}
const MyButton = (props) => {
    return (
        <Button className="theme-button"
            disabled={props.disableOn}
            onClick={props.submit}
        >
            {
                props.showProgress
                    ?
                    <span className="spinner">
                        <Icon icon="fa-cached" />
                    </span>
                    : ''
            }
            Upload
  </Button>
    )
}

const SelectFile = (props) => {
    return (
        <FormGroup className="v-select-file">
            <label></label>
            <label htmlFor="selectImg">
                <Icon icon="fa-image" />
            </label>
            <label>Select Image</label>
            <input type="file" id="selectImg"
                ref={props.fileRef}
                name="file"
                onChange={props.fileSelected}
            />
            {
                props.imgError ? <ShowError msg="Only images are allowed (.jpeg, .jpg, .png)" /> : ''
            }
        </FormGroup>
    )
}


// WEBPACK FOOTER //
// ./src/admin/manageImg_md.jsx